export const bookingDetails = {
  arrivalPlace: {
    address: '',
    poiName: '',
    poiStopName: '',
    lat: '',
    lon: '',
    type: '',
    isPoi: false,
    poiStopId: '',
    stopId: '',
    error: '',
  },
  departurePlace: {
    address: '',
    poiName: '',
    poiStopName: '',
    lat: '',
    lon: '',
    type: '',
    isPoi: false,
    poiStopId: '',
    stopId: '',
    error: '',
  },
  prefilledOpsZone: null as any,
  animalsTransportation: false,
  rideType: '',
  tripType: 'ONE_WAY',
  outwardDate: {
    type: '',
    date: '',
    time: '',
  },
  returnDate: {
    type: '',
    date: '',
    time: '',
  },
  vehicleCategoryId: '',
  vehicleCategoryLocalizedName: '',
  adults: 0,
  children: 0,
  selectedFeatures: [] as any[],
  rideList: [] as any[],
  checkoutInfo: {
    passengerDetails: {
      isAnotherPassenger: false,
      phone: '',
      firstName: '',
      lastName: '',
      email: '',
    },
    paymentType: 'PRE_AUTHORIZATION',
    paymentMethod: null as string | null,
    flightDetails: '',
    commentForOutward: '',
    commentForReturn: '',
    temporaryReservation: {
      bookingRequestId: '',
      reservationId: '',
      reservedTill: null as number | null,
      remainingTime: null as number | null,
      ignoreRemainingTime: false,
    },
  },
  bookingDetails: {
    bookingRequestId: null as string | null,
    originalOutwardFeaturePrice: null as number | null,
    originalOutwardPrice: null as number | null,
    outwardMaxDetourTimeInMinutes: null as number | null,
    originalReturnFeaturePrice: null as number | null,
    originalReturnPrice: null as number | null,
    outwardDistanceKm: null as number | null,
    outwardTimeInMinutes: null as number | null,
    outwardTripAllowedReason: null as string | null,
    outwardTripAllowedShiftId: null as string | null,
    outwardTripAllowedTripId: null as string | null,
    outwardTripAllowedVehicleId: null as string | null,
    rejectReasonCode: null as string | null,
    rejectReasonMessage: null as string | null,
    rejected: true,
    returnMaxDetourTimeInMinutes: null as number | null,
    returnDistanceKm: null as number | null,
    returnTimeInMinutes: null as number | null,
    returnTripAllowedReason: null as string | null,
    returnTripAllowedShiftId: null as string | null,
    returnTripAllowedTripId: null as string | null,
    returnTripAllowedVehicleId: null as string | null,
    selectedFeatures: null as any[] | null,
  },
};

export type BookingState = typeof bookingDetails;
